import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Logo } from './Logo';

export const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="footer-inner">
        {/* Left Column */}
        <div>
          <Logo variant="light" />
          <p className="footer-description">
            Plan. Price. Build.
          </p>
        </div>

        {/* Centre Column */}
        <div>
          <div className="footer-label">NAVIGATE</div>
          <div className="footer-links">
            <button onClick={() => navigate('/upload')} className="footer-link">Services</button>
            <button onClick={() => navigate('/')} className="footer-link">Examples</button>
            <button onClick={() => navigate('/tender-process')} className="footer-link">Process</button>
            <button onClick={() => navigate('/faq')} className="footer-link">FAQ</button>
            <button onClick={() => navigate('/contact')} className="footer-link">Contact</button>
          </div>
        </div>

        {/* Right Column */}
        <div>
          <div className="footer-label">LEGAL</div>
          <div className="footer-links">
            <a href="/terms" className="footer-link">Privacy Policy</a>
            <a href="/terms" className="footer-link">Terms and Conditions</a>
            <a href="mailto:team@schedulesofwork.com" className="footer-link">team@schedulesofwork.com</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© 2025 Schedules of Works. All rights reserved.</span>
      </div>
    </footer>
  );
};
